import { EventEmitter } from 'events';
import dispatcher from './dispatcher';
import { DID_LOGIN, REGISTERED, DISMISS, EXPORT_DB } from './Actions';

class UploadStore extends EventEmitter {
  constructor() {
    super();
    this.isExported = false;
  }

  viewUser() {
    // return this.user;
  }

  checkExported() {
    return this.isExported;
  }

  handleActions(action) {
    switch (action.type) {
      case EXPORT_DB:
        this.isExported = true;
        this.emit('exported');
        break;

      case DISMISS:
        this.isExported = false;
        this.emit('exported');
        break;
    }
  }
}

const uploadStore = new UploadStore();

dispatcher.register(uploadStore.handleActions.bind(uploadStore));

export default uploadStore;
